import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  includeBearerTokenInterceptor,
  provideKeycloak
} from 'keycloak-angular';

import { resolveBootstrapConfig } from './config/resolve-env';
import { routes } from './app.routes';
import { apiInterceptor } from './common/Interceptor/api_interceptor';
import { loadingInterceptor } from './common/Interceptor/loading_interceptor';
import { environmentInterceptor } from './interceptors/environment.interceptor';
import { marketResearchReducer } from './super-god-bhive/market-research/state/market-research.reducer';
import { MarketResearchEffects } from './super-god-bhive/market-research/state/market-research.effects';

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const bootstrapConfig = resolveBootstrapConfig();

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        environmentInterceptor,
        loadingInterceptor,
        includeBearerTokenInterceptor,
        apiInterceptor
      ])
    ),
    provideAnimationsAsync(),
    provideStore({ marketResearch: marketResearchReducer }),
    provideEffects([MarketResearchEffects]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }), 
    // Retains last 25 states
    // Restrict extension to log-only mode
    provideKeycloak({
      config: bootstrapConfig.keycloak,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        pkceMethod: 'S256'
      }
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [
        { urlPattern: new RegExp(`^${escapeRegExp(bootstrapConfig.bhiveUrl)}(/.*)?$`) },
        { urlPattern: new RegExp(`^${escapeRegExp(bootstrapConfig.supergodUrl)}(/.*)?$`) },
        { urlPattern: new RegExp(`^${escapeRegExp(bootstrapConfig.borServiceUrl)}(/.*)?$`) }
      ]
    }
  ]
};
